import { http } from "./http";

export const propertyMediaApi = {
  // params sugeridos: { auction_property_id, media_type, limit, offset }
  list: (params) => http.get("/property-media", { params }).then((r) => r.data),

  getById: (id) => http.get(`/property-media/${id}`).then((r) => r.data),

  // create “manual” (caso você já tenha uma URL pronta)
  // payload: { auction_property_id, media_type, url, label?, uploaded_by_user_id }
  create: (payload) =>
    http.post("/property-media", payload).then((r) => r.data),

  update: (id, payload) =>
    http.put(`/property-media/${id}`, payload).then((r) => r.data),

  // upload: envia o arquivo e os metadados
  // payload: { file, auction_property_id, media_type, label?, uploaded_by_user_id }
  upload: ({
    file,
    auction_property_id,
    media_type,
    label,
    uploaded_by_user_id,
  }) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("auction_property_id", auction_property_id);
    formData.append("media_type", media_type);
    if (label != null) formData.append("label", label);
    formData.append("uploaded_by_user_id", uploaded_by_user_id);

    return http
      .post("/property-media/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  remove: (id) => http.delete(`/property-media/${id}`).then((r) => r.data),
};
